import React from 'react';
import Button from 'react-bootstrap/Button';

import './style.scss';

interface IViewButtonProps {
  onClick: TButtonOnClick;
  className?: string;
  isDisabled?: boolean;
}

interface IViewButtonState {}

export default class ViewButton extends React.Component<IViewButtonProps, IViewButtonState> {
  static defaultProps: IViewButtonProps = {
    onClick: () => null,
    className: '',
    isDisabled: false,
  };

  render() {
    const { onClick, className } = this.props;

    return <Button className={`view-btn ${className}`} onClick={onClick} disabled={this.props.isDisabled} />;
  }
}
